export default {
  noData: 'Không có dữ liệu',
  EmptyData: 'Chưa có dữ liệu',
  search: 'Tìm kiếm...',
  FeaturesIsDeveloping: 'Tính năng đang phát triển',
  command: {
    add: 'Thêm',
    edit: 'Sửa',
    update: 'Cập nhật',
    delete: 'Xóa',
    deleteField: 'Xóa thông tin',
    duplicate: 'Nhân bản',
    more: 'Thêm nữa...',
    save: 'Lưu',
    saveNew: 'Lưu & Thêm',
    close: 'Đóng',
    hide: 'Ẩn',
    help: 'Giúp',
    cancel: 'Hủy',
    accept: 'Đồng ý',
    saveAndNew: 'Lưu và thêm mới',
    confirm: 'Xác nhận',
    notConfirm: 'Không xác nhận',
    export: 'Xuất khẩu',
    finish: 'Hoàn thành',
    load: 'Nạp',
    print: 'In',
    filter: 'Lọc',
    refresh: 'Nạp',
    setting: 'Thiết lập',
    default: 'Mặc định',
    list: 'Danh sách',
    addDetail: 'Thêm dòng',
    addDetailShortKey: 'Thêm dòng (F9)',
    import: 'Nhập khẩu',
    logout: 'Đăng xuất',
    next: 'Tiếp theo',
    cancel: 'Hủy',
    back: 'Quay lại',
    move: 'Di chuyển',
    minimize: 'Thu gọn',
    inactive: 'Ngừng theo dõi'
  },
  List: {
    SearchEmptyText: 'Tìm kiếm'
  },
  module: {
    employee: 'Nhân viên',
    employeeType: 'Loại cán bộ',
    payrollItem: 'Khoản lương',
    inventoryItem: 'Vật tư, Hàng hóa',
    buPlanWithDraw: 'Rút dự toán tiền gửi',
    bUTransfer: 'Chuyển khoản kho bạc vào tài khoản tiền gửi',
    accountingObject: 'Cán bộ',
    department: 'Phòng/ban',
    account: 'Tài khoản',
    currency: 'Loại tiền',
    baWithdraw: 'Chi tiền gửi',
    inventoryCategory: 'Loại vật tư, hàng hóa',
    stock: 'Kho',
    buPlanReceipt: 'Nhận dự toán',
    budgetChapter: 'Chương',
    budgetProvide: 'Mã dự phòng',
    typeOfFund: 'Loại quỹ',
    bankInfoCategory: 'Loại tài khoản tiền gửi kho bạc',
    budgetGroupItem: 'Nhóm mục chi',
    budgetSourceProperty: 'Tính chất nguồn kinh phí',
    cAReceipt: 'Phiếu thu',
    budgetSource: 'Nguồn kinh phí',
    bankInfo: 'Tài khoản ngân hàng, kho bạc',
    bUVoucherList: 'Bảng kê chứng từ thanh toán',
    budgetItem: 'Mục - Tiểu mục',
    bUPlanAdjustment: 'Điều chỉnh dự toán',
    budgetKindItem: 'Loại - Khoản',
    sUTransfer: 'Điều chuyển CCDC',
    sUIncrement: 'Ghi tăng CCDC',
    sUDecrement: 'Ghi giảm CCDC',
    bUPlanWDAdjustment: 'Điều chỉnh kinh phí',
    pUInvoice: 'Hóa đơn mua hàng',
    iNTransfer: 'Chuyển kho',
    iNAdjustment: 'Điều chỉnh tồn kho',
    statistic: 'Mã thống kê',
    purchasePurpose: 'Nhóm HH, DV mua vào',
    cAPayment: 'Phiếu chi',
    budgetFees: 'Phí, lệ phí',
    accountTransfer: 'Tài khoản kết chuyển',
    bADeposit: 'Phiếu thu',
    cAReceiptSale: 'Phiếu thu bán hàng',
    sAInvoice: 'Bán hàng chưa thu tiền',
    bABankTransfer: 'Chuyển tiền nội bộ',
    bUBudgetReserve: 'Dự toán giữ lại',
    gLVoucher: 'Chứng từ nghiệp vụ khác',
    activity: 'Hoạt động',
    task: 'Nhiệm vụ',
    customerVendor: 'Khách hàng, nhà cung cấp',
    accountingObjectCategory: 'Loại khách hàng, nhà cung cấp',
    invoiceFormNumber: 'Mẫu số hóa đơn',
    voucherType: 'Loại chứng từ',
    sAReturn: 'Hàng bán trả lại',
    gLVoucher: 'Chứng từ nghiệp vụ khác',
    activity: 'Hoạt động',
    bUCommitmentRequest: 'Đề nghị cam kết chi',
    bUCommitmentAdjustment: 'Điều chỉnh cam kết chi',
    bUOpeningCommitment: 'Nhập cam kết chi ban đầu',
    project: 'Dự án',
    targetProgram: 'Chương trình mục tiêu',
    projectBudgetDetail: 'Chi tiết tổng mức đầu tư',
    contract: 'Hợp đồng',
    topic: 'Đề tài',
    gLVoucherList: 'Bảng tổng hợp chứng từ',
    workItem: 'Công trình, HMCT',
    BUTransferPurchase: 'Chuyển khoản kho bạc mua vật tư hàng hóa',
    INInwardFromINAdjustment: 'Nhập kho từ điều chỉnh tồn kho',
    INInwardFromINAdjustmentChangeAmount:
      'Nhập kho từ điều chỉnh tồn kho (Có điều chỉnh giá trị)',
    INOutwardFromINAdjustment: 'Xuất kho từ điều chỉnh tồn kho',
    INOutwardFromINAdjustmentChangeAmount:
      'Xuất kho từ điều chỉnh tồn kho (Có điều chỉnh giá trị)',
    FAVoucherDepreciation: 'Lấy hao mòn tự nhiên TSCĐ từ QLTS.VN',
    FAVoucherIncreament: 'Ghi tăng TSCĐ từ QLTS.VN',
    FAVoucherAdjustment: 'Đánh giá lại TSCĐ từ QLTS.VN',
    FAVoucherDepreciate: 'Lấy khấu hao TSCĐ từ QLTS.VN',
    FAVoucherDecrement: 'Ghi giảm TSCĐ từ QLTS.VN',
    bATransfer: 'Tiền đang chuyển',
    bUPlanImport: 'Nhập dự toán',
    cRERepList: 'Báo cáo tài chính', 
    openingSupplyEntry: 'Công cụ dụng cụ',
    autoBusiness: 'Định khoản tự động',
    fundStructure: 'Cơ cấu vốn',
    cRERepExportList: 'Nộp báo cáo cho kho bạc',
    defaultAccount: 'Tài khoản ngầm định',
    cRERepSettlement: 'Báo cáo quyết toán',
    cAReceiptSale : 'Thu tiền khách hàng',
    salaryScale: 'Ngạch lương',
    pAOption: 'Quy định lương, thuế, bảo hiểm',
    toolType: 'Loại công cụ dụng cụ',
    toolList: 'Công cụ dụng cụ',
  },
  Filter: {
    Title: 'Filter',
    Button: {
      Clear: 'Clear',
      Cancel: 'Cancel',
      Save: 'Save'
    }
  },
  National: {
    de: 'Germany',
    us: 'USA',
    vn: 'VietNam',
    la: 'Laos'
  },
  Package: {
    Trial:  'Trial',
    Standard: 'Standard',
    Professional: 'Professional',
    Enterprise: 'Enterprise',
    Starter: 'Starter',
    Advanced:'Advanced'
  }
};
